module.exports = __webpack_public_path__ + "static/media/nodejs.eb529b49.svg";